// frontend/src/components/Demo/SolicitarDemo.js
// Formulario público "Solicitar demostración" (botón del hero del landing).
// Las solicitudes llegan al panel admin > Solicitudes demo
// (backend/src/routes/solicitudesDemo.js). Fondo igual al del login; la
// tarjeta reutiliza los estilos del registro de empresa.

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../Registro/Registro.css';
import './SolicitarDemo.css';

const ESTADO_INICIAL = {
  nombre: '',
  empresa: '',
  email: '',
  telefono: '',
  extension: '',
  comentarios: '',
  sitio_web: '' // campo trampa para bots, oculto
};

const SolicitarDemo = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState(ESTADO_INICIAL);
  const [error, setError] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: name === 'extension' ? value.replace(/\D/g, '') : value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setEnviando(true);
    try {
      const response = await fetch('/api/solicitudes-demo', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        setError(data.error || 'No pudimos enviar tu solicitud. Intenta de nuevo.');
        return;
      }
      setEnviado(true);
    } catch {
      setError('Error de conexión con el servidor.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <div className="demo-container">
      <div className="demo-shapes" aria-hidden="true">
        <span className="demo-shape demo-shape-1" />
        <span className="demo-shape demo-shape-2" />
        <span className="demo-shape demo-shape-3" />
      </div>

      {enviado ? (
        <div className="registro-card registro-card-exito demo-card">
          <img src="/isotipotransparente.png" alt="" className="registro-icono-exito" />
          <h1>¡Gracias, {form.nombre.split(' ')[0]}!</h1>
          <p>
            Recibimos tu solicitud. Nuestro equipo se pondrá en contacto contigo en
            <strong> {form.email}</strong> o al teléfono que nos compartiste para agendar tu demostración.
          </p>
          <Link to="/" className="btn-registro-primary">Volver al inicio</Link>
        </div>
      ) : (
        <div className="registro-card demo-card">
          <img src="/Logotransparente.png" alt="PsyTest" className="registro-logo" />
          <h1>Solicita una demostración</h1>
          <p className="registro-sub">
            Déjanos tus datos y te mostramos cómo PsyTest puede ayudarte a evaluar y contratar
            con más certeza. Te contactaremos a la brevedad.
          </p>

          <form onSubmit={handleSubmit} className="registro-form">
            <div className="registro-field">
              <label htmlFor="demo-nombre">Nombre</label>
              <input id="demo-nombre" type="text" name="nombre" value={form.nombre} onChange={handleChange} required maxLength={150} autoComplete="name" disabled={enviando} />
            </div>

            <div className="registro-field">
              <label htmlFor="demo-empresa">Nombre de la empresa</label>
              <input id="demo-empresa" type="text" name="empresa" value={form.empresa} onChange={handleChange} required maxLength={200} autoComplete="organization" disabled={enviando} />
            </div>

            <div className="registro-field">
              <label htmlFor="demo-email">Correo electrónico</label>
              <input id="demo-email" type="email" name="email" value={form.email} onChange={handleChange} required maxLength={200} autoComplete="email" disabled={enviando} />
            </div>

            <div className="registro-field-row demo-telefono-row">
              <div className="registro-field">
                <label htmlFor="demo-telefono">Teléfono</label>
                <input id="demo-telefono" type="tel" name="telefono" value={form.telefono} onChange={handleChange} required maxLength={30} pattern="[0-9+()\-\s]{7,30}" title="Solo números, espacios y los signos + ( ) -" autoComplete="tel" disabled={enviando} />
              </div>
              <div className="registro-field demo-extension">
                <label htmlFor="demo-extension">Ext. <span className="demo-opcional">(opcional)</span></label>
                <input id="demo-extension" type="text" inputMode="numeric" name="extension" value={form.extension} onChange={handleChange} maxLength={10} disabled={enviando} />
              </div>
            </div>

            <div className="registro-field">
              <label htmlFor="demo-comentarios">Comentarios <span className="demo-opcional">(opcional)</span></label>
              <textarea
                id="demo-comentarios"
                name="comentarios"
                value={form.comentarios}
                onChange={handleChange}
                rows={4}
                maxLength={2000}
                placeholder="Cuéntanos sobre tu empresa, cuántas personas contratas al mes o qué puestos quieres evaluar."
                disabled={enviando}
              />
            </div>

            <div className="demo-trampa" aria-hidden="true">
              <label htmlFor="demo-sitio">Sitio web</label>
              <input id="demo-sitio" type="text" name="sitio_web" value={form.sitio_web} onChange={handleChange} tabIndex={-1} autoComplete="off" />
            </div>

            {error && <div className="registro-error">{error}</div>}

            <button type="submit" className="btn-registro-primary" disabled={enviando}>
              {enviando ? 'Enviando...' : 'Solicitar demostración'}
            </button>
          </form>

          <button type="button" className="registro-volver" onClick={() => navigate('/')}>← Volver al inicio</button>
        </div>
      )}
    </div>
  );
};

export default SolicitarDemo;
